import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Index from "./pages/Home";
import ContactUs from "./pages/ContactUs";
import PP from "./pages/PrivacyPolicy";
import TermsofUse from "./pages/TermsofUse";
import ComplainPolicy from "./pages/ComplainPolicy";
import CookieBanner from "./components/universal/cookieBanner";
import { HelmetProvider } from "react-helmet-async";
import SchemaComponent from "./components/universal/schema-component";
import ReactGA from "react-ga4";
import { useEffect } from "react";
import Thankyou from "./pages/Thankyou";
import ExternalRedirect from "./pages/externalRedirectoion";
function App() {
  const TRACKING_ID = "G-KP89EPNVY6";
  useEffect(() => {
    ReactGA.initialize(TRACKING_ID);
    // Send pageview with a custom path
    // ReactGA.send({
    //   hitType: "pageview",
    //   page: "/landingpage",
    //   title: "Landing Page",
    // });
  }, []);
  return (
    <Router>
      <HelmetProvider>
        <SchemaComponent />
      </HelmetProvider>
      <CookieBanner />
      <Routes>
        <Route
  path="/"
  element={<ExternalRedirect />}
/>
        <Route path="/thank-you" element={<Thankyou />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/privacy-policy" element={<PP />} />
        <Route path="/terms-of-use" element={<TermsofUse />} />
        <Route path="/complain-policy" element={<ComplainPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;
